import DesignPreview from './DesignPreview';

export default DesignPreview;